export const actionTypes = {
  BLUR_MEDIA_ITEM_FIELD: "edit-media/BLUR_MEDIA_ITEM_FIELD",
  CONTRIBUTOR_DIALOG_FIELD_BLURRED:
    "edit-media/CONTRIBUTOR_DIALOG_FIELD_BLURRED",
  CONTRIBUTOR_DIALOG_FIELD_CHANGED:
    "edit-media/CONTRIBUTOR_DIALOG_FIELD_CHANGED",
  CONTRIBUTOR_DIALOG_ROLE_CHANGED: "edit-media/CONTRIBUTOR_DIALOG_ROLE_CHANGED",
  FETCH_VOCABULARY: "edit-media/FETCH_VOCABULARY",
  FETCH_VOCABULARY_COMPLETE: "edit-media/FETCH_VOCABULARY_COMPLETE",
  HIDE_DRAWER: "edit-media/HIDE_DRAWER",
  HIDE_CONTRIBUTOR_DIALOG: "edit-media/HIDE_CONTRIBUTOR_DIALOG",
  HIDE_REMOVE_CONTRIBUTOR_DIALOG: "edit-media/HIDE_REMOVE_CONTRIBUTOR_DIALOG",
  MEDIA_ITEM_FIELD_CHANGED: "edit-media/MEDIA_ITEM_FIELD_CHANGED",
  REMOVE_CONTRIBUTOR: "edit-media/REMOVE_CONTRIBUTOR",
  SAVE_ADD_CONTRIBUTOR: "edit-media/SAVE_ADD_CONTRIBUTOR",
  SAVE_EDIT_CONTRIBUTOR: "edit-media/SAVE_EDIT_CONTRIBUTOR",
  SAVE_MEDIA_ITEM: "edit-media/SAVE_MEDIA_ITEM",
  SAVE_MEDIA_ITEM_COMPLETE: "edit-media/SAVE_MEDIA_ITEM_COMPLETE",
  SELECT_ACTIVE_TAB: "edit-media/SELECT_ACTIVE_TAB",
  SHOW_ADD_CONTRIBUTOR_DIALOG: "edit-media/SHOW_ADD_CONTRIBUTOR_DIALOG",
  SHOW_EDIT_CONTRIBUTOR_DIALOG: "edit-media/SHOW_EDIT_CONTRIBUTOR_DIALOG",
  SHOW_REMOVE_CONTRIBUTOR_DIALOG: "edit-media/SHOW_REMOVE_CONTRIBUTOR_DIALOG",
  SHOW_DRAWER: "edit-media/SHOW_DRAWER",

  SHOW_EDIT_THUMBNAIL_DIALOG: "edit-media/SHOW_EDIT_THUMBNAIL_DIALOG",
  HIDE_EDIT_THUMBNAIL_DIALOG: "edit-media/HIDE_EDIT_THUMBNAIL_DIALOG",
  SELECT_THUMBNAIL_FILE: "edit-media/SELECT_THUMBNAIL_FILE",
  SAVE_THUMBNAIL_FILE: "edit-media/SAVE_THUMBNAIL_FILE",
  THUMBNAIL_UPDATE_COMPLETE: "edit-media/THUMBNAIL_UPDATE_COMPLETE",
};

export const blurMediaItemField = (field, value) => ({
  type: actionTypes.BLUR_MEDIA_ITEM_FIELD,
  field,
  value,
});
export const contributorDialogFieldBlurred = (field, value) => ({
  type: actionTypes.CONTRIBUTOR_DIALOG_FIELD_BLURRED,
  field,
  value,
});
export const contributorDialogFieldChanged = (path, value) => ({
  type: actionTypes.CONTRIBUTOR_DIALOG_FIELD_CHANGED,
  path,
  value,
});
export const contributorDialogRoleChanged = id => ({
  type: actionTypes.CONTRIBUTOR_DIALOG_ROLE_CHANGED,
  id,
});
export const fetchVocabulary = () => ({ type: actionTypes.FETCH_VOCABULARY });
export const fetchVocabularyComplete = (
  languages,
  licenseTypes,
  categories,
  contributorRoles,
  contributorTypes,
) => ({
  type: actionTypes.FETCH_VOCABULARY_COMPLETE,
  languages,
  licenseTypes,
  categories,
  contributorRoles,
  contributorTypes,
});
export const hideContributorDialog = () => ({
  type: actionTypes.HIDE_CONTRIBUTOR_DIALOG,
});
export const hideRemoveContributorDialog = () => ({
  type: actionTypes.HIDE_REMOVE_CONTRIBUTOR_DIALOG,
});
export const hideDrawer = () => ({ type: actionTypes.HIDE_DRAWER });
export const mediaItemFieldChanged = (path, value) => ({
  type: actionTypes.MEDIA_ITEM_FIELD_CHANGED,
  path,
  value,
});
export const removeContributor = index => ({
  type: actionTypes.REMOVE_CONTRIBUTOR,
  index,
});
export const saveAddContributor = () => ({
  type: actionTypes.SAVE_ADD_CONTRIBUTOR,
});
export const saveEditContributor = () => ({
  type: actionTypes.SAVE_EDIT_CONTRIBUTOR,
});
export const saveMediaItem = mediaItem => ({
  type: actionTypes.SAVE_MEDIA_ITEM,
});
export const saveMediaItemComplete = mediaItem => ({
  type: actionTypes.SAVE_MEDIA_ITEM_COMPLETE,
  mediaItem,
});
export const selectActiveTab = index => ({
  type: actionTypes.SELECT_ACTIVE_TAB,
  index,
});
export const showAddContributorDialog = () => ({
  type: actionTypes.SHOW_ADD_CONTRIBUTOR_DIALOG,
});
export const showEditContributorDialog = index => ({
  type: actionTypes.SHOW_EDIT_CONTRIBUTOR_DIALOG,
  index,
});
export const showRemoveContributorDialog = index => ({
  type: actionTypes.SHOW_REMOVE_CONTRIBUTOR_DIALOG,
  index,
});
export const showDrawer = mediaItem => ({
  type: actionTypes.SHOW_DRAWER,
  mediaItem,
});

export const showEditThumbnailDialog = () => ({
  type: actionTypes.SHOW_EDIT_THUMBNAIL_DIALOG,
});

export const hideEditThumbnailDialog = () => ({
  type: actionTypes.HIDE_EDIT_THUMBNAIL_DIALOG,
});

export const selectThumbnailFile = file => ({
  type: actionTypes.SELECT_THUMBNAIL_FILE,
  file,
});

export const saveThumbnailFile = (mediaId, file) => ({
  type: actionTypes.SAVE_THUMBNAIL_FILE,
  mediaId,
  file,
});

export const thumbnailUpdateComplete = thumbnailUrl => ({
  type: actionTypes.THUMBNAIL_UPDATE_COMPLETE,
  thumbnailUrl,
});
